'use strict';
'use client';
import { j as s } from "../../external/react/jsx-runtime.js";
import x from "../../external/classnames/index.js";
import { useState as j, useEffect as g, Fragment as p } from "react";
import o from "./accordion.module.scss.js";
import h from "./AccordionItem.js";
import m from "../Divider/index.js";
const S = ({
  className: d,
  itemClassName: f,
  header: r,
  items: c,
  onItemOpen: i,
  border: l = !0
}) => {
  const [a, n] = j(null), u = (e, t) => {
    a === e ? n(null) : (n(e), i && i(t));
  };
  return g(() => {
    const e = c.findIndex((t) => t.isActive);
    e !== -1 && n(e);
  }, [c]), /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: x(
        o.accordion,
        l ? o["accordion--bordered"] : "",
        d
      ),
      children: [
        r ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx("div", { className: o.accordion__header, children: r }),
          l && c.length > 0 ? /* @__PURE__ */ s.jsx(m, { margin: !1 }) : null
        ] }) : null,
        c.map((e, t) => /* @__PURE__ */ s.jsxs(p, { children: [
          /* @__PURE__ */ s.jsx(
            h,
            {
              className: f,
              title: e.title,
              content: e.content,
              isActive: a === t,
              onClick: () => u(t, e)
            }
          ),
          l && t < c.length - 1 ? /* @__PURE__ */ s.jsx(m, { margin: !1 }) : null
        ] }, t))
      ]
    }
  );
};
export {
  S as default
};
